<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { Layers } from 'lucide-vue-next'
import { useAuthStore } from '@/stores/auth'
import type { DashboardInstance } from './dashboard-process'

defineProps<{
    instances: DashboardInstance[]
}>()

const { t } = useI18n()
const auth = useAuthStore()

async function switchTo(name: string) {
    await auth.changeInstance(name)
}
</script>

<template>
    <section class="mb-6">
        <div class="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
            <div class="flex items-center gap-3 px-4 py-3 border-b border-gray-200 flex-wrap">
                <div class="w-6 h-6 rounded-lg bg-teal/10 flex items-center justify-center">
                    <Layers class="w-3.5 h-3.5 text-teal" />
                </div>
                <span class="text-sm font-semibold text-ink">{{ t('dashboard.instances.title') }}</span>
                <span class="text-xs text-gray-500 ml-1">{{ instances.length }}</span>
            </div>
            <div class="overflow-x-auto">
                <table class="w-full text-sm border-collapse">
                    <thead>
                        <tr class="bg-gray-50">
                            <th class="px-3 py-2.5 text-xs font-semibold text-gray-500 text-left border-b border-gray-200">{{ t('dashboard.instances.name') }}</th>
                            <th class="px-3 py-2.5 text-xs font-semibold text-gray-500 text-right border-b border-gray-200">{{ t('dashboard.instances.events') }}</th>
                            <th class="px-3 py-2.5 text-xs font-semibold text-gray-500 text-right border-b border-gray-200">{{ t('dashboard.instances.scans24h') }}</th>
                            <th class="px-3 py-2.5 text-xs font-semibold text-gray-500 text-right border-b border-gray-200">{{ t('dashboard.instances.devices') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="inst in instances" :key="inst.id"
                            class="hover:bg-gray-50 cursor-pointer transition-colors duration-100 border-b border-gray-200"
                            @click="switchTo(inst.name)">
                            <td class="px-3 py-3.5 text-sm font-medium text-ink">{{ inst.name }}</td>
                            <td class="px-3 py-3.5 text-right text-xs tabular-nums text-gray-600">{{ inst.activeEventsCount }}</td>
                            <td class="px-3 py-3.5 text-right text-xs tabular-nums text-gray-600">{{ inst.scansLast24h }}</td>
                            <td class="px-3 py-3.5 text-right text-xs tabular-nums text-gray-600">{{ inst.devicesOnline }} / {{ inst.devicesTotal }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</template>
